export default "__VITE_ASSET__D2PbH4rq__"